export const WIN_MESSAGES = ["Great Job!", "Awesome", "Well done!"];
